/**
 * .tuMetrics {"tu1": 0.91, "tu2": 0.93, "tu3": 2, "notes": "Single app-wide update banner from version.json + waiting SW", "tuVersion": "2.5"}
 * .help "Shows the What's-new refresh prompt on every route, including login, when this tab is behind the live deploy."
 */
import useVersionCheck from '@/hooks/useVersionCheck';
import { updatesHrefFor } from '@/hooks/versionBanner';
import { UPDATES_ROUTE } from '@/constants/updates';
import UpdateNotification from '@/shared/common/UpdateNotification';

export default function AppUpdateHost() {
  const { hasUpdate, latestVersion, refreshApp, dismissUpdate, bannerMode } = useVersionCheck(60_000);
  if (!hasUpdate || !latestVersion) return null;

  const updatesHref = updatesHrefFor(latestVersion, bannerMode, UPDATES_ROUTE);
  const versionLabel = latestVersion.releaseNotesVersion || latestVersion.packageVersion || null;

  return (
    <UpdateNotification
      mode={bannerMode}
      onRefresh={() => void refreshApp()}
      onSeeWhatsNew={() => void refreshApp(updatesHref || undefined)}
      onDismiss={dismissUpdate}
      versionLabel={versionLabel}
      summary={bannerMode === 'major' ? latestVersion.releaseSummary || null : null}
      updatesHref={updatesHref}
    />
  );
}
